(() => {
  let scheduled = false;
  const profiles = [
    { test: /diary|planner|notebook|sidekick|calendar|highlighter|note block/i, title: 'Make room for more.', badge: 'Picked for your plans', sub: 'A little more structure for your everyday.', picks: [/productivity-planner/, /weekly-desk-planner/, /pen|highlighter|note-block/], relevant: /planner|pen|highlighter|notebook|sidekick|note-block/ },
    { test: /magnet|pinboard|pin board|magnetic board/i, title: 'Make it your own.', badge: 'For your board', sub: 'Little additions for the things you want to keep in view.', picks: [/magnet|wooden-pins/, /display-tray/], relevant: /magnet|pin|display-tray/ },
    { test: /shelf|shelv|bedside|ledge/i, title: 'Complete your space.', badge: 'For your home', sub: 'Thoughtful pieces to bring your space together.', picks: [/display-tray/, /shelf|bedside|ledge/], relevant: /tray|shelf|bedside|ledge|vase/ },
    { test: /bathroom|towel|soap|shower|toilet/i, title: 'Everyday, considered.', badge: 'For your bathroom', sub: 'Bring a little more order to your daily routine.', picks: [/soap|shower/, /towel|toilet/], relevant: /soap|shower|towel|toilet/ }
  ];
  const fallback = {title:'A little something more.',badge:'Chosen for you',sub:'Thoughtful additions for your everyday.',picks:[],relevant:/.*/};

  // Optimistic presentation; UpCart remains responsible for the actual cart mutation.
  let protectionDesired = null;
  let protectionFlight = null;
  let protectionTimer = null;
  const protectionInput = () => document.querySelector('#CartPopup .upcart-public-addons__toggle-switch input');
  const protectionActual = input => input.getAttribute('aria-checked') === 'true';
  function paintProtection() {
    const button = document.querySelector('#CartPopup .mot-protection-checkbox');
    const input = protectionInput();
    if (!button || !input) return;
    const value = String(protectionDesired === null ? protectionActual(input) : protectionDesired);
    if (button.getAttribute('aria-checked') !== value) button.setAttribute('aria-checked', value);
    const busy = String(!!protectionFlight);
    if (button.getAttribute('aria-busy') !== busy) button.setAttribute('aria-busy', busy);
  }
  function pollProtection() {
    clearTimeout(protectionTimer);
    const input = protectionInput();
    if (!input || !protectionFlight) return;
    const busy = input.disabled || input.closest('label')?.getAttribute('aria-disabled') === 'true';
    const elapsed = Date.now() - protectionFlight.started;
    if (!busy && elapsed > 200 && protectionActual(input) === protectionFlight.value) {
      const actual = protectionActual(input);
      const issued = protectionFlight.value;
      protectionFlight = null;
      if (protectionDesired !== issued) {
        if (protectionDesired === actual) protectionDesired = null;
        else sendProtection();
      } else {
        protectionDesired = null;
        if (actual !== issued) {
          const status = document.querySelector('#CartPopup .mot-protection-status');
          if (status) status.textContent = 'Package protection could not be updated. Please try again.';
        }
      }
      paintProtection();
      return;
    }
    if (elapsed > 20000) {
      protectionFlight = null;
      protectionDesired = null;
      const status = document.querySelector('#CartPopup .mot-protection-status');
      if (status) status.textContent = 'The cart is still updating. Please check package protection before checkout.';
      paintProtection();
      return;
    }
    protectionTimer = setTimeout(pollProtection, 80);
  }
  function sendProtection() {
    const input = protectionInput();
    if (!input || protectionFlight || protectionDesired === null) return;
    if (input.disabled) {
      clearTimeout(protectionTimer);
      protectionTimer = setTimeout(sendProtection, 80);
      return;
    }
    if (protectionActual(input) === protectionDesired) {
      protectionDesired = null;
      paintProtection();
      return;
    }
    protectionFlight = {value: protectionDesired, started: Date.now()};
    input.click();
    paintProtection();
    protectionTimer = setTimeout(pollProtection, 80);
  }
  function enhanceProtection(cart) {
    const wrapper = cart.querySelector('.upcart-public-addons__toggle-wrapper');
    if (!wrapper) return;
    if (!wrapper.querySelector('.mot-protection-checkbox')) {
      const button = document.createElement('button');
      button.type = 'button';
      button.className = 'mot-protection-checkbox';
      button.setAttribute('role', 'checkbox');
      button.setAttribute('aria-label', 'Add package protection');
      button.addEventListener('click', () => {
        const input = protectionInput();
        if (!input) return;
        protectionDesired = !(protectionDesired === null ? protectionActual(input) : protectionDesired);
        const status = cart.querySelector('.mot-protection-status');
        if (status) status.textContent = '';
        paintProtection();
        sendProtection();
      });
      wrapper.appendChild(button);
      const status = document.createElement('span');
      status.className = 'mot-protection-status';
      status.setAttribute('role', 'status');
      wrapper.appendChild(status);
    }
    paintProtection();
  }

  function text(el, value) { if (el && el.textContent !== value) el.textContent = value; }
  function update() {
    scheduled = false;
    const cart = document.querySelector('#CartPopup');
    if (!cart) return;
    const header = cart.querySelector('[data-upcart-chunk="header-title-content"]');
    const count = header?.textContent.match(/\d+/)?.[0] || '0';
    if (header && header.dataset.motCount !== count) header.dataset.motCount = count;
    const items = cart.querySelector('.upcart-public-cart-items');
    const profile = profiles.find(p => p.test.test(items?.textContent || '')) || fallback;
    const existing = new Set([...items?.querySelectorAll('a[href]') || []].map(a => a.pathname));
    const upsell = cart.querySelector('.upcart-public-upsell');
    if (upsell) {
      const slides = [...upsell.querySelectorAll('.upcart-public-component-carousel__slide')];
      const candidates = slides.map((slide,index) => {
        const link=slide.querySelector('a[href]');
        const handle=slide.querySelector('[data-upcart-upsell]')?.getAttribute('data-upcart-upsell') || '';
        const match=profile.picks.findIndex(p=>p.test(handle));
        return {slide,index,handle,path:link?.pathname,score:match>=0?match:profile.relevant.test(handle)?10:100};
      }).filter(p=>p.path&&!existing.has(p.path));
      candidates.sort((a,b)=>a.score-b.score||a.index-b.index);
      const selected=[];
      for (const candidate of candidates) { if (!selected.some(p=>p.path===candidate.path)) selected.push(candidate); if(selected.length===2)break; }
      // Describe the recommendations actually displayed, rather than the cart category.
      const labels = selected.map(p => p.handle + ' ' + (p.slide.querySelector('.upcart-public-component-upsell-tile__title-link')?.textContent || ''));
      const copyProfile = profiles.find(p => labels.length && labels.every(label => p.test.test(label))) || fallback;
      const heading = upsell.querySelector('[data-upcart-chunk="upsell-title"] p');
      text(heading, copyProfile.title);
      let badge = upsell.querySelector('.mot-discovery-badge');
      if (!badge) { badge = document.createElement('span'); badge.className='mot-discovery-badge'; heading?.parentElement.appendChild(badge); }
      text(badge, copyProfile.badge);
      let intro = upsell.querySelector('.mot-discovery-intro');
      if (!intro) { intro=document.createElement('p'); intro.className='mot-discovery-intro'; upsell.querySelector('[data-upcart-chunk="upsell-title"]')?.after(intro); }
      text(intro, copyProfile.sub);
      slides.forEach(slide=>{const picked=selected.some(p=>p.slide===slide);if(slide.classList.contains('mot-discovery-picked')!==picked)slide.classList.toggle('mot-discovery-picked',picked);});
      selected.forEach((p,index)=>{
        if(p.slide.style.order!==String(index))p.slide.style.order=String(index);
        p.slide.setAttribute('aria-label','Recommended product '+(index+1)+' of '+selected.length);
        p.slide.querySelectorAll('img').forEach(img => {
          const url = new URL(img.getAttribute('src'), location.href);
          if (url.hostname === 'cdn.shopify.com' || url.hostname === location.hostname) {
            url.searchParams.delete('height');
            url.searchParams.set('width', '720');
            if (img.src !== url.href) img.src = url.href;
          }
        });
        const copy={'productivity-planner':'Turn monthly plans into daily focus.','weekly-desk-planner':'See the week at a glance.'}[p.handle];
        if(copy&&!p.slide.querySelector('.mot-discovery-product-copy')){const description=document.createElement('p');description.className='mot-discovery-product-copy';description.textContent=copy;p.slide.querySelector('.upcart-public-component-upsell-tile__title-link')?.after(description);}
      });
    }
    const note=cart.querySelector('[data-upcart-chunk="notes-title"] ins');
    text(note,'Add a note');
    const discount=cart.querySelector('.upcart-public-discount-code');
    if(discount&&!discount.querySelector('.mot-discount-toggle')) {
      const button=document.createElement('button');button.type='button';button.className='mot-discount-toggle';button.innerHTML='<span>Have a discount code?</span><span aria-hidden="true">+</span>';button.setAttribute('aria-expanded','false');
      button.addEventListener('click',()=>{const open=button.getAttribute('aria-expanded')!=='true';button.setAttribute('aria-expanded',String(open));discount.classList.toggle('mot-discount-open',open);button.lastElementChild.textContent=open?'−':'+';if(open)discount.querySelector('input')?.focus();});
      discount.prepend(button);
    }
    text(cart.querySelector('.upcart-public-addons__content-title'),'Package protection');
    text(cart.querySelector('[data-upcart-chunk="addon-description"]'),'Optional cover for damage, theft or loss.');
    enhanceProtection(cart);
    const toggle=cart.querySelector('.upcart-public-addons__toggle-switch');
    if(toggle&&toggle.getAttribute('aria-label')!=='Add package protection')toggle.setAttribute('aria-label','Add package protection');
  }
  function queue(){if(scheduled)return;scheduled=true;requestAnimationFrame(update);}
  const observer=new MutationObserver(queue);
  observer.observe(document.body,{subtree:true,childList:true,characterData:true});
  queue();
})();
